'use client'

import { Typography } from '@mui/material'
import Button from '@mui/material/Button'
import { FallbackProps } from 'react-error-boundary'
import { useNavigate } from 'react-router-dom'

const ErrorSvg = '/assets/Error.svg'

export function OopsError({ error, resetErrorBoundary }: FallbackProps) {
  const navigate = useNavigate()
  return (
    <section className='flex items-center h-full p-16  '>
      <div className='container flex flex-col items-center justify-center px-5 mx-auto my-8'>
        <img
          width='631'
          height='379'
          src={process.env.PUBLIC_URL + ErrorSvg}
          alt='Error'
        />
        <div className='max-w-md text-center'>
          <Typography className='text-2xl font-semibold md:text-3xl'>
            SomeThing Went Wrong !!!
          </Typography>
          <p className='mt-4 mb-8 dark:text-gray-400'>
            Contact the website admnistrator to resolve.
          </p>
          <Button
            onClick={() => resetErrorBoundary(() => navigate('/'))}
            variant='contained'
          >
            Back To Home
          </Button>
        </div>
      </div>
    </section>
  )
}
